import * as React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { sortiereProdukte } from '../utils/sortHelpers';
import {
  Alert, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, Paper, TextField,
  IconButton, Collapse, Box, Button, Grid
} from '@mui/material';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';

function tageBisVerfall(verfallsdatum) {
  const heute = new Date();
  const verfall = new Date(verfallsdatum);
  const diffTime = verfall - heute;
  return Math.floor(diffTime / (1000 * 60 * 60 * 24));
}

export default function VorratsTabelle() {
  const [produkte, setProdukte] = useState([]);
  const [suche, setSuche] = useState('');
  const [offen, setOffen] = useState(null); // dbid der geöffneten Zeile
  const [deleteMsg, setDeleteMsg] = useState('');
  const [deleteMsgType, setDeleteMsgType] = useState('success'); // 'success' oder 'error'

  const navigate = useNavigate();
  const location = useLocation();

    // für Sortierung
    const [sortField, setSortField] = useState('verfall');
    const [sortDirection, setSortDirection] = useState('asc');

  const [successMsg, setSuccessMsg] = useState('');

  useEffect(() => {
    if (location.state && location.state.successMsg) {
      setSuccessMsg(location.state.successMsg);

      // Nach dem Setzen der Meldung das History-State zurücksetzen,
      // damit beim Neuladen die Meldung nicht mehr erscheint:
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  useEffect(() => {
    fetch('https://app.satoha.de/service/?modus=get-vorrat-liste')
      .then(res => res.json())
      .then(data => setProdukte(data));
  }, []);

const gefilterteProdukte = produkte.filter(p => {
  const sucheLower = suche.toLowerCase();
  const markerString = `#${p.marker}`; // Marker mit #
  
  return (
    (p.name && p.name.toLowerCase().includes(sucheLower)) ||
    (p.menge && p.menge.toString().toLowerCase().includes(sucheLower)) ||
    (p.ort && p.ort.toLowerCase().includes(sucheLower)) ||
    (p.verfallsdatum && p.verfallsdatum.toLowerCase().includes(sucheLower)) ||
    markerString.toLowerCase().includes(sucheLower)
  );
});

const handleLoeschen = async (produktId) => {
  if (!window.confirm("Willst du dieses Produkt wirklich löschen?")) return;
  try {
    const response = await fetch(
      `https://app.satoha.de/service/?action=delete-vorrat&type=id&value=${produktId}`,
      { method: 'POST' }
    );
    const result = await response.json();
    if (result.success) {
      setDeleteMsgType('success');
      setDeleteMsg(result.message || "Produkt gelöscht!");
      setProdukte(prev => prev.filter(p => p.dbid !== produktId));
      setTimeout(() => setDeleteMsg(''), 3000);
    } else {
      setDeleteMsgType('error');
      setDeleteMsg(result.message || "Löschen fehlgeschlagen.");
      setTimeout(() => setDeleteMsg(''), 5000);
    }
  } catch (err) {
    setDeleteMsgType('error');
    setDeleteMsg("Netzwerkfehler beim Löschen.");
    setTimeout(() => setDeleteMsg(''), 5000);
  }
};

// Zeige die Meldung nur einmal an
  useEffect(() => {
    if (location.state && location.state.successMsg) {
      setSuccessMsg(location.state.successMsg);
      // Optional: Nach 2 Sekunden automatisch ausblenden
    //   const timer = setTimeout(() => setSuccessMsg(''), 2000);
    //   return () => clearTimeout(timer);
    }
  }, [location.state]);

  const handleSort = (field) => {
    if (sortField === field) {
        setSortDirection(prev => (prev === 'asc' ? 'desc' : 'asc'));
    } else {
        setSortField(field);
        setSortDirection('asc');
    }
  };

  const sortierteProdukte = sortiereProdukte(gefilterteProdukte, sortField, sortDirection);
  

  return (
    
    <Paper sx={{ width: '100%', overflow: 'hidden', marginTop: 2 }}>
<Grid container spacing={1} alignItems="center" sx={{ p: 1, mb: 1 }}>
  <Grid item xs>
    <TextField
      placeholder="Suche"
      variant="outlined"
      size="small"
      fullWidth
      sx={{
        '& input': {
          py: { xs: 0.5, sm: 1, md: 1.3 },
          fontSize: { xs: '0.8rem', sm: '1.1rem', md: '0.9rem' }
        }
      }}
      value={suche}
      onChange={e => setSuche(e.target.value)}
    />
  </Grid>
  <Grid item>
    <Button
      variant="contained"
      color="primary"
      size="small"
      onClick={() => navigate('/neu')}
      sx={{
        height: { xs: 26, sm: 44, md: 42 },
        fontSize: { xs: '0.8rem', sm: '1.1rem', md: '0.9rem' },
        px: { xs: 1.5, sm: 3, md: 3 }
      }}
    >
      + Neues Produkt
    </Button>
  </Grid>
  <Grid item>
    <Button
      variant="contained"
      color="primary"
      size="small"
      onClick={() => navigate('/inventur')}
      sx={{
        height: { xs: 26, sm: 44, md: 42 },
        fontSize: { xs: '0.8rem', sm: '1.1rem', md: '0.9rem' },
        px: { xs: 1.5, sm: 3, md: 3 }
      }}
    >
      Inventur
    </Button>
  </Grid>
</Grid>



        {successMsg && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {successMsg}
        </Alert>
      )}
        {deleteMsg && (
        <div style={{
            background: deleteMsgType === 'success' ? '#4caf50' : '#f44336', // grün oder rot
            color: 'white',
            padding: '12px',
            borderRadius: '4px',
            marginBottom: '16px',
            textAlign: 'center',
            fontWeight: 'bold',
            transition: 'opacity 0.3s ease'
        }}>
            {deleteMsg}
        </div>
        )}


      <TableContainer>
        <Table
          size="small"
          sx={{
            '& .MuiTableCell-root': {
              px: { xs: 0.4, sm: 2 },
              py: { xs: 1.2, sm: 1 },
              fontSize: { xs: '0.8rem', sm: '1rem' },
            }
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell 
                sx={{
                    display: { xs: 'none', sm: 'table-cell' } // Versteckt auf xs (Handy)
                }}
                />
              <TableCell
                sx={{
                    pl: '14px !important'
                }}
              >
                <TableSortLabel
                    active={sortField === 'name'}
                    direction={sortField === 'name' ? sortDirection : 'asc'}
                    onClick={() => handleSort('name')}
                >
                <b>Name</b>
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                    active={sortField === 'menge'}
                    direction={sortField === 'menge' ? sortDirection : 'asc'}
                    onClick={() => handleSort('menge')}
                >
                <b>Menge</b>
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                    active={sortField === 'ort'}
                    direction={sortField === 'ort' ? sortDirection : 'asc'}
                    onClick={() => handleSort('ort')}
                >
                <b>Lagerplatz</b>
                </TableSortLabel>
              </TableCell>
              <TableCell>
                <TableSortLabel
                    active={sortField === 'verfallsdatum'}
                    direction={sortField === 'verfallsdatum' ? sortDirection : 'asc'}
                    onClick={() => handleSort('verfallsdatum')}
                >
                <b>Tage bis Verfall</b>
                </TableSortLabel>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortierteProdukte.map(p => (
              <React.Fragment key={p.dbid}>
                <TableRow hover onClick={() => setOffen(offen === p.dbid ? null : p.dbid)}>
                  <TableCell 
                    sx={{
                      display: { xs: 'none', sm: 'table-cell' } // Versteckt auf xs (Handy)
                    }}
                  >
                    <IconButton size="small">
                      {offen === p.dbid ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                    </IconButton>
                  </TableCell>
                  <TableCell
                    sx={{
                        pl: '14px !important'
                    }}
                  >{p.name}</TableCell>
                  <TableCell>{p.menge} {p.einheit}</TableCell>
                  <TableCell>{p.ort}</TableCell>
                  <TableCell>{tageBisVerfall(p.verfallsdatum)}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={5}>
                    <Collapse in={offen === p.dbid} timeout="auto" unmountOnExit>
                      <Box margin={2}>
                        <b>Marker:</b> #{p.marker}<br />
                        <b>Name:</b> {p.name}<br />
                        <b>Menge:</b> {p.menge}<br />
                        <b>Lagerplatz:</b> {p.ort}<br />
                        <b>Verfallsdatum:</b> {new Date(p.verfallsdatum).toLocaleDateString('de-DE')}
                        <Box mt={2}>
                          <Button
                            variant="contained"
                            color="primary"
                            sx={{ mr: 1 }}
                            onClick={e => {
                                e.stopPropagation();
                                navigate(`/bearbeiten/${p.dbid}`);
                            }}
                            >
                            Bearbeiten
                          </Button>
                          <Button
                            variant="outlined"
                            color="error"
                            onClick={e => {
                                e.stopPropagation();
                                handleLoeschen(p.dbid);
                            }}
                            >
                            Löschen
                          </Button>
                        </Box>
                      </Box>
                    </Collapse>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
        <br />
      </TableContainer>
    </Paper>
  );
}
